import { Component } from '@theme/component';
import { VestidoController } from './cosautil-vestido.js?v=0261d697d3d10ef7f9deef5d87deead180ecbf62da496270961997189b83cb3a';

export class CosautilVestido extends Component {
  connectedCallback(){super.connectedCallback();this.initialize();}
  updatedCallback(){super.updatedCallback();this.initialize();}
  disconnectedCallback(){this.controller?.destroy();this.controller=null;super.disconnectedCallback();}
  initialize(){
    this.controller?.destroy();this.controller=null;
    const roots=[...this.querySelectorAll('[data-vestido-root]')];const profiles=[...this.querySelectorAll('[data-vestido-profile]')];
    const failClosed=()=>roots.forEach(root=>{root.querySelectorAll('[data-open-cod],[data-color-choice],[data-pack]').forEach(button=>button.disabled=true);root.querySelectorAll('[data-native-status]').forEach(node=>node.textContent='La compra de este producto todavía no está disponible.');});
    if(roots.length!==1||profiles.length!==1||roots[0].dataset.mode!=='native'){failClosed();return;}
    const root=roots[0];
    try{const profile=JSON.parse(profiles[0].textContent);if(!profile.assets||typeof profile.assets!=='object'||!profile.nativeProfile||typeof profile.nativeProfile!=='object')throw new Error('Invalid native profile');this.controller=new VestidoController(root,{assets:profile.assets,nativeProfile:profile.nativeProfile});}
    catch{failClosed();}
  }
}
if(!customElements.get('cosautil-vestido'))customElements.define('cosautil-vestido',CosautilVestido);
